export const state = {
    // 1.初始化用户信息
    userInfo: sessionStorage.getItem("userInfo") ? JSON.parse(sessionStorage.getItem("userInfo")) : {}
}
export const getters = {
    // 2.导出用户信息
    userInfo(state) {
        return state.userInfo
    }
}
export const mutations = {
    // 3.修改（userInfo）
    changeuserInfo(state, userInfo) {
        state.userInfo = userInfo;
    }
}